<template>
    <div>
        <Spinner/>
    </div>
</template>

<script>
    import Spinner from "./Spinner";
    export default {
        name: "DownloadPage",
        components: {Spinner},
        async mounted() {
            if (this.$store.state.applicationVersion === 'pro' && sessionStorage.initialStateFromLocalStorage) {
                const initialState = JSON.parse(sessionStorage.initialStateFromLocalStorage);
                const projectList = initialState.projectList;
                if (projectList) {
                    await this.$store.dispatch('projectList/createDynamicModules', projectList);
                }
            }
            const projectUUID = this.$route.query.projectUUID;
            const redirectPath = this.$route.query.redirect;
            if (projectUUID && redirectPath) {
                let project = await this.$store.dispatch('projectList/LOAD_PROJECT_BY_GUID', projectUUID)
                if (!project) {
                    alert('Данный проект не найдет!');
                    this.redirectProjectsPage();
                    return;
                }
                const productsUsed = this.$store.getters[`projectList/${projectUUID}/designList/PRODUCTS_USED`];
                await this.$store.dispatch('UI/products/GET_PRODUCT_BY_UUID_FROM_SERVER', productsUsed);
                this.$router.replace(redirectPath).catch(() => {});
            } else {
                this.$router.replace(redirectPath).catch(() => {});
            }
        },
        methods: {
            redirectProjectsPage: function () {
                if(this.$store.state.applicationVersion === 'pro'){
                    this.$router.replace({name: "projects"}).catch(() => {});
                }else {
                    this.$router.replace({name: "liteProjects"}).catch(() => {});
                }
            }
        }
    }
</script>

<style scoped>

</style>
